module.exports = "https://web-assets-production.autolist.com/_next/static/images/quickpicks-end-1577f46be9b0261f1f1b4d19058d4d6b.png";